export default "__VITE_ASSET__3cf98b7f__"